import React from 'react'
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { NoticeBadge } from '~/src/components/atoms/Badge/NoticeBadge/NoticeBadge'
import { i18n } from '~/src/libs/i18next/config'

export type TSidebarListItemProps = {
  icon: React.ReactNode | null
  text: string
  count?: number
}

/**
 * SidebarListItem Component
 *
 * @example
 * ```ts
 *  <SidebarListItem icon={<HomeIcon />} text={'Home'} />
 * ```
 * @param __namedParameters TSidebarListItemProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const SidebarListItem: React.FC<TSidebarListItemProps> = ({ icon, text, count }): JSX.Element => {
  if (icon) {
    return (
      <ListItemButton>
        <ListItemIcon sx={{ '.MuiSvgIcon-root': { width: '0.85em' } }}>{icon}</ListItemIcon>
        <ListItemText
          primary={text}
          sx={{
            '.MuiTypography-root': {
              fontSize: '1rem',
            },
          }}
        />
      </ListItemButton>
    )
  }

  return (
    <List component="div" disablePadding>
      <ListItemButton sx={{ pl: 2, py: '4px' }}>
        <ListItemText
          primary={text}
          sx={{
            '.MuiTypography-root': {
              fontSize: '0.875rem',
            },
            display: 'contents'
          }}
        />
        {text === i18n.t('sidebar.contact_order') && <NoticeBadge notice={count} />}
      </ListItemButton>
    </List>
  )
}
